import React from "react";
import CodeEditor from "../../../../../components/BuilderComponents/CodeEditor/CodeEditor";
// import Textarea from "../../../../../components/FormComponents/Textarea";

const EditContent = (props) => {
  const { editFieldData, setEditFieldData } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };

  return (
    <>
      <CodeEditor
        height="500px"
        containerClass={"w_100 h_100"}
        language="html"
        value={editFieldData.value}
        handleChange={(code) => handleChangeInput("value", code)}
        enableBacktickTrigger={false}
      />
    </>
  );
};

export default EditContent;
